import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {CoverageAnalysisView} from '../rfi-coverage-analysis-dialog.types';
import {CoverageKpiCardComponent} from '../coverage-kpi-card/coverage-kpi-card.component';
import {CoverageSectionComponent} from '../coverage-section/coverage-section.component';
import {CoverageFunctionGroupComponent} from '../coverage-function-group/coverage-function-group.component';
import {CoverageTabHeaderComponent} from '../coverage-tab-header/coverage-tab-header.component';
import {CoverageNoteComponent} from '../coverage-note/coverage-note.component';

@Component({
  selector: 'app-coverage-extras-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AppNumberPipe,
    TranslocoPipe,
    CoverageKpiCardComponent,
    CoverageSectionComponent,
    CoverageFunctionGroupComponent,
    CoverageTabHeaderComponent,
    CoverageNoteComponent,
  ],
  templateUrl: './coverage-extras-tab.component.html',
})
export class CoverageExtrasTabComponent {
  readonly view = input.required<CoverageAnalysisView>();

  protected readonly expansion = computed(() => this.view().expansion);
  protected readonly requestedShare = computed(() => 100 - this.expansion().percent);
  protected readonly expansionNoteParams = computed(() => ({
    extra: this.expansion().additionalCount,
  }));
}
